import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";

import DialogBackdrop from "./DialogBackdrop";

export default function ServicesAndClaimsFilterModel({
  modalState,
  setModalState,
}) {
  const { register, handleSubmit } = useForm({
    defaultValues: {},
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const setFilter = (data) => {
    let updatedSearchParams = new URLSearchParams(searchParams.toString());
    if (data.type) updatedSearchParams.set("type", data.type);
    if (data.sortby) updatedSearchParams.set("sortby", data.sortby);
    setSearchParams(updatedSearchParams.toString());
    setModalState(false);
  };
  return (
    <Dialog
      open={modalState}
      onClose={() => setModalState(false)}
      className="ui-dialogs"
    >
      {/* The backdrop, rendered as a fixed sibling to the panel container */}
      <DialogBackdrop />
      {/* Full-screen container to center the panel */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel
          role="dialog"
          aria-modal="true"
          className="ui-default-dialog"
        >
          <Dialog.Title className="font-body text-xl font-bold text-left">
            Filter Options
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            aria-label="claims or services filter option"
            onClick={() => setModalState(false)}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />
          <Dialog.Description>
            Filter your items by date and status.
          </Dialog.Description>
          <div className="mt-4 lg:hidden">
            <label
              id="ID_categoryDialogLabel"
              htmlFor="ID_categoryDialog"
              className="block mb-1 mr-2"
            >
              Category
            </label>
            <select
              id="ID_categoryDialog"
              aria-labelledby="ID_categoryDialogLabel"
            >
              <option>Show all</option>
              <option>-----------------------</option>
            </select>
          </div>
          <div className="mt-4 lg:hidden">
            <label
              id="ID_searchPolicy2Label"
              htmlFor="ID_searchPolicy2"
              className="block pb-1 mr-2"
            >
              Search By Policy
            </label>
            <div className="flex flex-1 w-full relative">
              <input
                id="ID_searchPolicy2"
                aria-labelledby="ID_searchPolicy2Label"
                aria-describedby=""
                type="text"
                className="pl-8"
                placeholder="Enter policy number or policy holder name"
              />
              <svg
                className="ui-icon text-theme-action w-4 h-4 absolute ml-2 mt-3"
                focusable="false"
                aria-hidden="true"
                role="presentation"
              >
                <use href="#ui-icon-search"></use>
              </svg>
            </div>
          </div>
          <form onSubmit={handleSubmit(setFilter)}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
              <fieldset>
                <legend>Sort by</legend>
                <div className="mt-1">
                  <label className="inline-flex sm:items-center text-sm font-normal">
                    <input
                      className="mr-2"
                      type="radio"
                      value="newesttooldest"
                      {...register("sortby")}
                    />
                    Newest to oldest
                  </label>
                </div>
                <div className="mt-1">
                  <label className="inline-flex sm:items-center text-sm font-normal">
                    <input
                      className="mr-2"
                      type="radio"
                      value="oldesttonewest"
                      {...register("sortby")}
                    />
                    Oldest to newest
                  </label>
                </div>
                {/* <div className="mt-1">
                  <label className="inline-flex items-center  text-sm font-normal">
                    <input
                      type="radio"
                      value="last30days"
                      {...register("sortby")} />
                    Last 30 days
                  </label>
                </div> */}
              </fieldset>
              <fieldset>
                <legend> Status</legend>
                <label className="ui-checkbox mt-1">
                  <input
                    type="checkbox"
                    value="pending"
                    {...register("type")}
                  />
                  <div className="ui-checkmark">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  <span>Pending</span>
                </label>
                <label className="ui-checkbox mt-1">
                  <input
                    type="checkbox"
                    value="processed"
                    {...register("type")}
                  />
                  <div className="ui-checkmark">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  <span>Processed</span>
                </label>
                <label className="ui-checkbox mt-1">
                  <input type="checkbox" value="other" {...register("type")} />
                  <div className="ui-checkmark">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  <span>Other</span>
                </label>
                <label className="ui-checkbox mt-1">
                  <input type="checkbox" value="denied" {...register("type")} />
                  <div className="ui-checkmark">
                    <svg
                      className="ui-icon w-2 h-2 text-white"
                      focusable="false"
                      aria-hidden="true"
                      role="presentation"
                    >
                      <use href="#ui-icon-checkmark"></use>
                    </svg>
                  </div>
                  <span>Denied</span>
                </label>
              </fieldset>
            </div>
            <div className="block text-right">
              <button
                className="ui-btn-secondary ui-btn-min-w mt-4"
                onClick={() => setModalState(false)}
              >
                Cancel
                <span className="sr-only">
                  {" "}
                  filtering to claims or services
                </span>
              </button>
              <button className="ui-btn-primary ui-btn-min-w mt-4">
                Apply Filters
                <span className="sr-only"> filter to claims or services</span>
              </button>
            </div>
          </form>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
